export default "__VITE_ASSET__3$etEgbo__"